import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

import EventEditActionButtons from '@/pages/CreateEventProcessingPage/ui/layout/EventEditActionButtons.vue'
import { IEventEdit } from '@/enitites/event'
import {
  useCreatePayoutAccountMutation,
  useDeletePayoutAccountMutation,
  useEventPayoutAccountQuery,
  usePayoutAccountsQuery,
  useRefreshPayoutSessionMutation,
  useSetEventPayoutAccountMutation,
  useSyncPayoutAccountMutation,
} from '@/features/payoutAccounts/api/queries'
import StripeOnboardingModal from '@/features/payoutAccounts/ui/StripeOnboardingModal.vue'
import {
  mdiTrashCanOutline,
  mdiDotsHorizontal,
  mdiPencilOutline,
  mdiRadioboxMarked,
  mdiRadioboxBlank,
  mdiLockOutline,
} from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventBankAccount',
  props: {
    eventData: null
  },
  emits: ["next", "back", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'next'): void
  (e: 'back'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  eventData: IEventEdit
};

const deletePayoutAccountMutation = useDeletePayoutAccountMutation()





const errorMessage = ref<string>()
const { data: accountsData, isLoading: accountsLoading, refetch } = usePayoutAccountsQuery()
const { data: eventAccountData, isLoading: eventAccountLoading } = useEventPayoutAccountQuery(props.eventData.id)
const createMutation = useCreatePayoutAccountMutation()
const refreshMutation = useRefreshPayoutSessionMutation()
const setMutation = useSetEventPayoutAccountMutation(props.eventData.id)
const syncMutation = useSyncPayoutAccountMutation()

const showOnboarding = ref(false)
const currentClientSecret = ref<string | null>(null)
const currentAccountId = ref<number | null>(null)

const isLoading = computed(() => accountsLoading.value || eventAccountLoading.value)
const accounts = computed(
  () => accountsData.value || (eventAccountData.value?.account && [eventAccountData.value.account]) || []
)
const serverSelectedId = computed(() => eventAccountData.value?.account?.id || null)
const optimisticSelectedId = ref<number | null>(null)
const selectedAccountId = computed(() => optimisticSelectedId.value ?? serverSelectedId.value)

const handleCreateAccount = async () => {
  try {
    const result = await createMutation.mutateAsync({
      label: 'Payout Account',
    })
    currentAccountId.value = result.accountId
    currentClientSecret.value = result.clientSecret
    showOnboarding.value = true
  } catch (e) {
    console.error('Failed to create account:', e)
  }
}

const handleSelectAccount = async (accountId: number) => {
  if (!accountId) return
  optimisticSelectedId.value = accountId
  try {
    await setMutation.mutateAsync({ accountId })
  } catch (e) {
    optimisticSelectedId.value = null
    console.error('Failed to set payout account:', e)
  }
}

const handleContinueOnboarding = async (accountId: number) => {
  try {
    const result = await refreshMutation.mutateAsync(accountId)
    currentAccountId.value = accountId
    currentClientSecret.value = result.clientSecret
    showOnboarding.value = true
  } catch (e) {
    console.error('Failed to refresh session:', e)
  }
}

const handleOnboardingComplete = async () => {
  showOnboarding.value = false
  currentClientSecret.value = null

  // Sync account status from Stripe before refetching
  if (currentAccountId.value) {
    try {
      await syncMutation.mutateAsync(currentAccountId.value)
    } catch (e) {
      console.error('Failed to sync account status:', e)
    }
  }
  currentAccountId.value = null

  await refetch()

  // Auto-select the newly created account if it's the only one
  const refreshedAccounts = accountsData.value || []
  const completeAccounts = refreshedAccounts.filter((a) => a.onboardingComplete)
  if (completeAccounts.length === 1 && !selectedAccountId.value) {
    await handleSelectAccount(completeAccounts[0].id)
  }
}

const handleDeleteAccount = async (accountId: number) => {
  deletePayoutAccountMutation.mutate(accountId, {
    onSuccess: async () => {
      await refetch()
    },
    onError: (err) => {
      console.error('Failed to delete account:', err)
    },
  })
}

function handleNext() {
  emit('next')
}

function handleCancel() {
  emit('cancel')
}

return { __sfc: true,deletePayoutAccountMutation, props, emit, errorMessage, accountsData, accountsLoading, refetch, eventAccountData, eventAccountLoading, createMutation, refreshMutation, setMutation, syncMutation, showOnboarding, currentClientSecret, currentAccountId, isLoading, accounts, serverSelectedId, optimisticSelectedId, selectedAccountId, handleCreateAccount, handleSelectAccount, handleContinueOnboarding, handleOnboardingComplete, handleDeleteAccount, handleNext, handleCancel, EventEditActionButtons, StripeOnboardingModal, mdiTrashCanOutline, mdiDotsHorizontal, mdiPencilOutline, mdiRadioboxMarked, mdiRadioboxBlank, mdiLockOutline }
}

})